export const CHANGE_CATEGORY = 'catalog.CHANGE_CATEGORY';
export const ADD_CATEGORY = 'catalog.ADD_CATEGORY';
export const CHANGE_ROOT_CATEGORY = 'catalog.CHANGE_ROOT_CATEGORY';
export const INIT_ROOT_CATEGORY = 'catalog.INIT_ROOT_CATEGORY';
export const CHANGE_CURRENT_CATEGORY = 'catalog.CHANGE_CURRENT_CATEGORY';